import { Component, Injectable } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { XpoSnackBar } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { ShipmentId } from '@xpo-ltl/sdk-common';
import { XpoLtlUpdateShipmentStatusesResponse } from '@xpo-ltl/ngx-ltl';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { IframeMessage, postIframeMessage } from '../shared/iframe-message';

// captures the last snackbar params so they can be forwarded via postMessage when the component closes.
@Injectable()
export class UpdateShipmentStatusSnackbar extends XpoSnackBar {
  lastParams: any;
  override open(params: any): MatSnackBarRef<any> {
    this.lastParams = params;
    return super.open(params);
  }
}

@Component({
  selector: 'app-update-shipment-status',
  template: `<xpo-ltl-update-shipment-status [shipmentIds]="shipmentIds$ | async" (close)="onClose($event)">
  </xpo-ltl-update-shipment-status>`,
  providers: [UpdateShipmentStatusSnackbar, { provide: XpoSnackBar, useExisting: UpdateShipmentStatusSnackbar }],
})
export class UpdateShipmentStatusComponent {
  shipmentIds$: Observable<ShipmentId[]>;

  constructor(
    private route: ActivatedRoute,
    private snackbar: UpdateShipmentStatusSnackbar
  ) {
    this.shipmentIds$ = this.route.queryParamMap.pipe(
      take(1),
      map((params) => {
        const proNumber = params.get('proNbr');
        const shipmentInstId = params.get('shipmentInstId');
        if (!proNumber && !shipmentInstId) {
          throw new Error('At least one of proNbr or shipmentInstId must be provided');
        }
        return [{ proNumber, shipmentInstId }] as ShipmentId[];
      })
    );
  }

  onClose(response?: XpoLtlUpdateShipmentStatusesResponse): void {
    // setTimeout 0 — same hack as pickup-request: the snackbar open() fires
    // just before the close output, so we need to wait one tick to capture lastParams
    setTimeout(() => {
      const snackbarInfo = this.snackbar.lastParams;
      const event = response ? 'submit' : 'close';

      const message: IframeMessage = { event };

      if (response || snackbarInfo) {
        message.data = {
          ...response,
          ...(snackbarInfo && { snackbar: snackbarInfo }),
        };
      }

      postIframeMessage(message);
      this.snackbar.lastParams = undefined;
    }, 0);
  }
}
